// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum RefundDisplayType {
  Customer = "CUSTOMER",
  CustomerPartial = "CUSTOMER_PARTIAL",
  Distributor = "DISTRIBUTOR",
}
export default RefundDisplayType;
